import { useEffect, useState } from 'react';

import { EditSamMenu } from './EditSamMenu';
import { TitleMenu } from './TitleMenu';
import { ILayoutProvider } from '../../../../context/LayoutContext';

interface IServiceMenuComponent {
  dataRow?: any;
  selectMenu?: string;
  setOpenRightMenu: any;
  updateTable: any;
  layoutService?: ILayoutProvider;
}

export const RightMenu = (props: IServiceMenuComponent) => {
  const { dataRow, selectMenu, setOpenRightMenu, updateTable, layoutService } =
    props;
  const [menu, setMenu] = useState('Actualizar');

  useEffect(() => {
    setMenu(selectMenu || '');
  });

  /**
   *Choose menu to show
   */
  const renderMenu = (): any => {
    switch (menu) {
      case 'Actualizar':
        return (
          <EditSamMenu
            row={dataRow}
            setOpenRightMenu={setOpenRightMenu}
            updateTable={updateTable}
            layoutService={layoutService}
          />
        );

      default:
        return false;
    }
  };

  return (
    <div className="flex w-full h-full flex-col items-center bg-white  shadow-[-6px_-1px_5px_#00000024] z-10 right-0">
      <div className="flex w-full h-[10%] ">
        <TitleMenu name={menu} />
      </div>
      <div className="flex w-full h-[85%] ">{renderMenu()}</div>
    </div>
  );
};
